import React from 'react';

import { filterGroupHeader } from './FilterPanelStyles';

export function GroupHeader(props: { readonly text: string }) {
  return <legend className={filterGroupHeader}>{props.text}</legend>;
}
